// import axios from 'axios';
// import configData from "../components/configFile.json";
import { API } from 'aws-amplify';

class ActivityLogService {

    getLogsForUser = async (UserName) => {
        var myInit = {
            body: {
                UserName: UserName
            }
        }
        return API.post('IAPI', 'ActivityLog/activityLogsForUser/', myInit)
            .then((res) => {
                return res;
            }).catch((error) => {
                return error;
            });
    }

    addActivityLog = async (userActivityLog) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                UserName: userActivityLog.UserName,
                ActivityType: userActivityLog.ActivityType,
                Session:""
            }
        }
        await API.post('IAPI', 'ActivityLog/add/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }

}

const activityLogService = new ActivityLogService();
export default activityLogService;